import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetBusinessUnits } from '../../../hooks/useBusinessUnits';
import { useGetSites } from '../../../hooks/useSites';
import { DialogSelect } from './DialogInputs';


function SiteOrBusinessUnitSelect({ controlIdPrefix, dialogData, setDialogData, fieldErrors }) {
    const { t } = useTranslation();
    const { businessUnits } = useGetBusinessUnits();
    const { sites } = useGetSites();

    const handleSelectSite = (e) => {
        const value = e.target.value;
        setDialogData({ ...dialogData, siteId: value || null, businessUnitId: null });
    };

    const handleSelectBusinessUnit = (e) => {
        const value = e.target.value;
        setDialogData({ ...dialogData, businessUnitId: value || null, siteId: null });
    };

    return (
        <>
            <DialogSelect controlId={`form${controlIdPrefix}Site`}
                title="Site"
                name="siteId"
                value={dialogData.siteId || ""}
                onChange={handleSelectSite}
                error={fieldErrors.siteId} >
                <option value="" key={0}>{t('Application.Controls.DefaultSelect')}</option>
                {sites.map((site) => <option value={site.id} key={site.id}>{site.name}</option>)}
            </DialogSelect>
            <DialogSelect controlId={`form${controlIdPrefix}BusinessUnit`}
                title="Business Unit"
                name="businessUnitId"
                value={dialogData.businessUnitId || ""}
                onChange={handleSelectBusinessUnit}
                error={fieldErrors.businessUnitId} >
                <option value="" key={0}>{t('Application.Controls.DefaultSelect')}</option>
                {businessUnits.map((bu) => <option value={bu.id} key={bu.id}>{bu.name}</option>)}
            </DialogSelect>
        </>
    );
}

export default SiteOrBusinessUnitSelect;